import '@progress/kendo-theme-default/dist/all.css'
import 'bootstrap/dist/css/bootstrap.css'
import * as History from 'history'
import Raven from 'raven-js'
import * as React from 'react'
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import * as redux from 'redux'
import 'rxjs/add/observable/from'
import 'rxjs/add/observable/fromEvent'
import 'rxjs/add/observable/fromEventPattern'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/take'
import 'rxjs/add/operator/throttleTime'
import {Observable} from 'rxjs/Observable'
import * as App from './app'
import * as AppUtils from './app/utils'
import './colors.css'
import * as Layout from './components/layout'
import * as Loading from './components/loading'
import * as Config from './config/reducer'
import * as RootConstants from './constants'
import {ApplicationState} from './rootReducer'
import * as Router from './router'
import './styles.css'

function isInternetExplorer() {

  const ua = navigator.userAgent;
  if (ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./)) {
    return true;
  } else {
    return false;
  }
}

declare const RASA_ADMIN_UI_API_ORIGIN: string
declare const RASA_INTEGRATIONS_API_ORIGIN: string
declare const RASA_API_URL: string
declare const RASA_KIBANA_UI_ORIGIN: string
declare const RASA_SEARCH_URL: string
declare const SENTRY_URL: string
declare const APPLICATION_ENV: string
declare const localStorage: any
declare const RASA_TRACK_URL: string
declare const RASA_SHARE_URL: string

const mount = document.createElement('div') as HTMLElement
document.body.appendChild(mount)

if (isInternetExplorer()) {
  render(
    <div>
      <div>
        <nav style={{background: '#223030', width: '100%', height: '65px', padding: '20px 20px'}}>
          <img src="http://rasaio-cdn.imgix.net/rasa/logo_simplified.png?h=30" style={{verticalAlign: 'middle'}}/>
        </nav>
      </div>
      <div style={{padding: '25px'}}>
        <h4 style={{textTransform: 'none'}}>Your browser is not supported.  Supported browsers include:</h4>
        <ul>
          <li>
            <a href="http://www.google.com/chrome" target="_blank">Chrome</a>
          </li>
          <li>
            <a href="http://www.getfirefox.com" target="_blank">Firefox</a>
          </li>
          <li>
            <a href="https://www.apple.com/safari/" target="_blank">Safari</a> (OSX only)
          </li>
          <li>
            <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank">
              Microsoft Edge</a> (Windows only)
          </li>
        </ul>
      </div>
    </div>,
    mount,
  )
} else {
  const history: History.History = History.createBrowserHistory()

  const production = typeof APPLICATION_ENV !== 'undefined' &&  APPLICATION_ENV === 'production'

  const router = {
    hash: history.location.hash,
    pathname: history.location.pathname,
    search: history.location.search,
  }
  const config: Config.State = {
    api: {
      key: localStorage.getItem(RootConstants.ACCESS_TOKEN),
      origin: RASA_ADMIN_UI_API_ORIGIN,
    },
    integrationsApi: {
      key: localStorage.getItem(RootConstants.ACCESS_TOKEN),
      origin: RASA_INTEGRATIONS_API_ORIGIN,
    },
    rasaApi: {
      key: null,
      url: RASA_API_URL,
    },
    reporting: {
      kibana_host: RASA_KIBANA_UI_ORIGIN,
    },
    search: {
      url: RASA_SEARCH_URL,
    },
    sentry: {
      config: {
        environment: production ? 'production' : 'staging',
      },
      url: SENTRY_URL,
    },
    share: {
      url: RASA_SHARE_URL,
    },
    shorten: {
      url: RASA_TRACK_URL,
    },
  }
  const raven = Raven.config(SENTRY_URL, config.sentry.config).install()
  const history$: Observable<History.LocationDescriptorObject> = Observable.fromEventPattern(history.listen)
  const dependencies = {history, history$, localStorage, window, raven}
  const store: redux.Store<ApplicationState> = AppUtils.createStore(dependencies)
  const store$ = Observable.from(store as any)
  const resize$ = Observable.fromEvent(window, 'resize')
  const resolveRoute = (routeContext: Router.ActionArgs<ApplicationState>) =>
    AppUtils.router.resolve(routeContext)
      .then((route: React.StatelessComponent) => render(
          <Provider store={store}>
            {route}
          </Provider>,
          mount,
        ),
      )
      .catch((error: Error) => {
        raven.captureException(error)
        store.dispatch({type: 'ERROR', error})
      })

  // Application bootstrap
  // Render initial page
  render(
    <Layout.PureLayout>
      <Loading.Loading center size={Loading.Sizes.LARGE}/>
    </Layout.PureLayout>,
    mount,
  )
  // Kick off application initilizing
  store.dispatch({
    config,
    router,
    type: App.INITIALIZING_APPLICATION,
  })
  // Setup listeners
  history$.subscribe((location: History.LocationDescriptorObject) => resolveRoute({...location, store}))
  store$
    .map(({app}: {app: {initialized: boolean}}) => app.initialized)
    .distinctUntilChanged()
    .filter(Boolean)
    .take(1)
    .subscribe(() => resolveRoute({...history.location, store}))
  resize$
    .throttleTime(250)
    .subscribe(() => store.dispatch(App.mediaQuerySet(window)))
}



// WEBPACK FOOTER //
// ./src/index.tsx